import AxiosInstance from "./Axios";
import Cookies from "universal-cookie";

const TradingGroupsRequest = async() => {
  try {
    const cookies = new Cookies();
    const token = cookies.get('token');
        
    const res = await AxiosInstance.get('/trading-groups', {
      headers: {
        'Authorization': `Bearer ${token}`
        }
    });

    return res;
  } catch (error) {
    console.error('error in request:', error);
    return null;
  }     
};

export default TradingGroupsRequest;
